module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-cancel-icon-blue.5396c7e5.svg";